// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-text {
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-text a {
  margin: 15px 0;
}

.ion-text-right {
  display: flex;
  flex-direction: row;
}

.custom-bonus-box {
  margin-top: 5px;
  border: 1px solid #dddddd;
}
.custom-bonus-box ion-input {
  background-color: var(--ion-color-light-tint);
  border-color: #ebebeb;
}
.custom-bonus-box ion-button {
  transform: translate(0, 27px);
  height: 40px;
  width: 90px;
}
.custom-bonus-box .wrapper {
  min-height: 90px;
}

.promo-code {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.promo-code .left {
  width: 67%;
}
.promo-code .right {
  display: flex;
}
.promo-code .right ion-icon {
  padding: 0 10px;
  font-size: 1.6rem;
  transform: translate(0px, 35px);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/player-migration/player-migration.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AAAI;EACI,cAAA;AAER;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,eAAA;EACA,yBAAA;AACJ;AACI;EACI,6CAAA;EACA,qBAAA;AACR;AAEI;EACI,6BAAA;EACA,YAAA;EACA,WAAA;AAAR;AAGI;EACI,gBAAA;AADR;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AAFJ;AAII;EACI,UAAA;AAFR;AAKI;EACI,aAAA;AAHR;AAKQ;EACI,eAAA;EACA,iBAAA;EACA,+BAAA;AAHZ","sourcesContent":[".nav-text{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    a{\n        margin: 15px 0;\n    }\n}\n\n.ion-text-right {\n    display: flex;\n    flex-direction: row;\n}\n\n.custom-bonus-box {\n    margin-top: 5px;\n    border: 1px solid #dddddd;\n\n    ion-input {\n        background-color: var(--ion-color-light-tint);\n        border-color: #ebebeb;\n    }\n\n    ion-button {\n        transform: translate(0, 27px);\n        height: 40px;\n        width: 90px;\n    }\n\n    .wrapper {\n        min-height: 90px;\n    }\n}\n\n.promo-code {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: space-between;\n\n    .left {\n        width: 67%;\n    }\n\n    .right {\n        display: flex;\n\n        ion-icon {\n            padding: 0 10px;\n            font-size: 1.6rem;\n            transform: translate(0px, 35px);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
